<template>
  <section v-if="!pending && offers.length > 0" class="border-b border-slate-200 bg-slate-50 py-14 md:py-16">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mb-8 flex flex-wrap items-end justify-between gap-5">
        <div>
          <span
            class="inline-flex rounded-full bg-orange-100 px-3 py-1.5 text-xs font-black uppercase tracking-[0.14em] text-orange-700"
          >
            Seleção especial
          </span>

          <h2 class="mt-3 text-3xl font-black tracking-tight text-[#071a3d]">
            Ofertas da semana
          </h2>

          <p
            class="mt-2 max-w-2xl text-sm leading-6 text-slate-500 md:text-base"
          >
            Produtos com preço promocional ou condições em destaque.
          </p>
        </div>

        <NuxtLink
          to="/produtos"
          class="inline-flex min-h-11 items-center justify-center rounded-xl border border-orange-600 px-5 py-2.5 text-sm font-bold text-orange-700 transition hover:bg-orange-50"
        >
          Ver todas as ofertas →
        </NuxtLink>
      </div>

      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <div
          v-for="product in offers"
          :key="String(product.id)"
          class="relative"
        >
          <div
            v-if="discountPercent(product)"
            class="absolute -right-2 -top-2 z-10 rounded-full bg-orange-600 px-3 py-2 text-xs font-black text-white shadow-lg"
          >
            -{{ discountPercent(product) }}%
          </div>

          <ProductCard :product="product" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import ProductCard from "~/components/ProductCard.vue";

const { data, pending } = await useFetch("/api/products/weekly-offers", {
  server: true,
  lazy: false,
  timeout: 15000,
  default: () => [],
  transform: (raw: any) => {
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.products)) return raw.products;
    if (Array.isArray(raw?.produtos)) return raw.produtos;
    return [];
  },
});

const normalizedProducts = computed(() => {
  if (!Array.isArray(data.value)) return [];

  return data.value.filter((product: any) => product?.id && product?.slug);
});

const offers = computed(() => normalizedProducts.value.slice(0, 4));

function discountPercent(product: any) {
  const current = Number(product?.price ?? product?.preco ?? 0);
  const old = Number(product?.old_price ?? product?.precoAntigo ?? 0);

  if (!current || !old || old <= current) return null;

  return Math.round((1 - current / old) * 100);
}
</script>
